/** Sign-in screens: a card on the gradient ground over the whole screen, the language pill at the top right. */
import type { ReactNode } from 'react';

import { LanguageSwitcher } from './LanguageSwitcher.js';
import { Logo } from './Logo.js';

export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="auth">
      <LanguageSwitcher className="auth-lang" />
      <div className="auth-card">
        <Logo />
        {children}
      </div>
    </div>
  );
}
